import React from 'react'

// styles
import {
    extendStylesSelect,
    extendStylesDropdown,
    DropDownTellerStyles,
} from './index.styles'

// component
import DropDownSearch from '../../../../../../Control/DropDownSearch'

const DropDownTeller = ({ extendStyles, label, ...props }) => {
    return (
        <>
            <div className="label-tools-item">{label}</div>
            <DropDownTellerStyles
                className="tools-item"
                extendStyles={extendStyles}
            >
                <DropDownSearch
                    {...props}
                    extendStylesSelect={extendStylesSelect}
                    extendStylesDropdown={extendStylesDropdown}
                />
            </DropDownTellerStyles>
        </>
    )
}

export default DropDownTeller
